import { createFileRoute } from '@tanstack/react-router';
import { ErrorState } from '@/components/domain/ErrorState';
import { opportunityDetailOptions } from '@/features/opportunities/detail/api';
import { OpportunityDetailPage } from '@/features/opportunities/detail/OpportunityDetailPage';
import { OpportunityDetailSearch } from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/opportunities/$id')({
  validateSearch: OpportunityDetailSearch,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(opportunityDetailOptions(params.id)),
  // 404 ou panne : `ErrorState` dans le shell, « Réessayer » relance le loader.
  errorComponent: ({ error, reset }) => <ErrorState error={error} onRetry={reset} />,
  component: OpportunityDetailPage,
});
